var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1700,
    viewBox: "0 0 1080 1700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2214_43837)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1700,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2214_43837)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1700,
    fill: "#A496DC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 1080,
    height: 1700,
    transform: "matrix(-1 0 0 1 1080 0)",
    fill: "url(#paint0_linear_2214_43837)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.858 512.551H492.479V478.098H504.858C515.182 478.098 521.535 484.546 521.535 495.324C521.535 506.079 515.182 512.551 504.858 512.551ZM500.42 505.603H504.578C510.37 505.627 513.547 502.795 513.547 495.324C513.547 487.829 510.37 485.022 504.484 484.998H500.42V505.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.761 478.098V512.551H535.819V478.098H543.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.845 512.551H558.466V478.098H570.845C581.169 478.098 587.522 484.546 587.522 495.324C587.522 506.079 581.169 512.551 570.845 512.551ZM566.407 505.603H570.565C576.357 505.627 579.534 502.795 579.534 495.324C579.534 487.829 576.357 485.022 570.471 484.998H566.407V505.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 565.693V542.571H409.592C414.836 542.571 417.631 545.796 417.647 550.236C417.631 554.659 414.804 557.868 409.529 557.868H405.107V565.693H401ZM405.107 554.451H408.96C412.056 554.435 413.446 552.679 413.446 550.236C413.446 547.76 412.056 546.052 408.96 546.052H405.107V554.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.136 565.693V542.571H441.243V562.18H451.351V565.693H437.136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.599 565.693H470.208L478.263 542.571H483.317L491.403 565.693H487.013L485.102 559.976H476.494L474.599 565.693ZM477.6 556.623H483.996L480.885 547.297H480.695L477.6 556.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.502 546.052V542.571H524.728V546.052H517.684V565.693H513.578V546.052H506.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.122 565.693V542.571H558.779V546.052H548.229V552.375H557.768V555.856H548.229V565.693H544.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.832 554.132C598.847 561.605 594.33 566.012 588.345 566.012C582.327 566.012 577.842 561.589 577.858 554.132C577.842 546.659 582.327 542.251 588.345 542.251C594.33 542.251 598.847 546.659 598.832 554.132ZM581.996 554.132C581.98 559.417 584.617 562.276 588.345 562.276C592.088 562.276 594.709 559.417 594.694 554.132C594.709 548.846 592.088 545.988 588.345 545.988C584.617 545.988 581.98 548.846 581.996 554.132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.668 565.693V542.571H627.26C632.504 542.571 635.299 545.541 635.315 549.948C635.299 553.094 633.878 555.425 631.193 556.527L636.136 565.693H631.556L627.071 557.23H622.775V565.693H618.668ZM622.775 553.749H626.628C629.724 553.765 631.114 552.423 631.114 549.948C631.114 547.489 629.724 546.052 626.628 546.052H622.775V553.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.025 542.571H660.079L666.871 559.369H667.155L673.946 542.571H679V565.693H675.052V549.788H674.831L668.482 565.629H665.544L659.195 549.725H659.005V565.693H655.025V542.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip2_2214_43837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.279 1533.7C481.148 1532.06 478.484 1531.1 475.591 1531.1C468.648 1531.1 463 1536.68 463 1543.54C463 1550.41 468.648 1556 475.591 1556C482.534 1556 488.182 1550.41 488.182 1543.54H488.194V1522.28H483.279V1533.7ZM475.591 1551.14C471.358 1551.14 467.915 1547.74 467.915 1543.55C467.915 1539.36 471.358 1535.96 475.591 1535.96C479.824 1535.96 483.267 1539.36 483.267 1543.55C483.267 1547.74 479.824 1551.14 475.591 1551.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.378 1531.1C527.485 1531.1 524.816 1532.07 522.69 1533.7V1522.28H517.775V1543.54H517.787C517.787 1550.41 523.435 1556 530.378 1556C537.321 1556 542.969 1550.41 542.969 1543.54C542.969 1536.68 537.321 1531.09 530.378 1531.09V1531.1ZM530.378 1551.14C526.145 1551.14 522.702 1547.74 522.702 1543.55C522.702 1539.36 526.145 1535.96 530.378 1535.96C534.611 1535.96 538.054 1539.36 538.054 1543.55C538.054 1547.74 534.611 1551.14 530.378 1551.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.409 1531.09C598.466 1531.09 592.818 1536.68 592.818 1543.55C592.818 1550.42 598.466 1556.01 605.409 1556.01C612.352 1556.01 618 1550.42 618 1543.55C618 1536.68 612.352 1531.09 605.409 1531.09ZM605.409 1551.14C601.176 1551.14 597.733 1547.74 597.733 1543.55C597.733 1539.36 601.176 1535.96 605.409 1535.96C609.642 1535.96 613.085 1539.36 613.085 1543.55C613.085 1547.74 609.642 1551.14 605.409 1551.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.985 1531.09C496.042 1531.09 490.394 1536.68 490.394 1543.55C490.394 1550.42 496.042 1556.01 502.985 1556.01C505.872 1556.01 508.536 1555.04 510.661 1553.41V1555.7H515.576V1543.55C515.576 1536.68 509.928 1531.09 502.985 1531.09ZM502.985 1551.14C498.751 1551.14 495.309 1547.74 495.309 1543.55C495.309 1539.36 498.751 1535.96 502.985 1535.96C507.218 1535.96 510.661 1539.36 510.661 1543.55C510.661 1547.74 507.218 1551.14 502.985 1551.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.027 1551.14C573.794 1551.14 570.351 1547.73 570.351 1543.54C570.351 1539.36 573.794 1535.95 578.027 1535.95V1531.09C577.764 1531.09 577.506 1531.1 577.254 1531.12C576.068 1531.11 575.106 1530.16 575.106 1528.99C575.106 1527.81 576.068 1526.86 577.254 1526.86C578.439 1526.86 579.402 1527.81 579.402 1528.99H584.317C584.317 1525.13 581.149 1522 577.254 1522C573.358 1522 570.191 1525.13 570.191 1528.99C570.191 1530.45 570.655 1531.81 571.439 1532.94C567.842 1535.14 565.442 1539.07 565.442 1543.54C565.442 1547.73 561.999 1551.14 557.766 1551.14C553.532 1551.14 550.089 1547.73 550.089 1543.54C550.089 1539.36 553.532 1535.95 557.766 1535.95V1531.09C557.502 1531.09 557.244 1531.1 556.992 1531.12C555.806 1531.11 554.844 1530.16 554.844 1528.99C554.844 1527.81 555.806 1526.86 556.992 1526.86C558.178 1526.86 559.14 1527.81 559.14 1528.99H564.055C564.055 1525.13 560.888 1522 556.992 1522C553.097 1522 549.929 1525.13 549.929 1528.99C549.929 1530.45 550.393 1531.81 551.178 1532.94C547.58 1535.14 545.18 1539.07 545.18 1543.54C545.18 1550.41 550.828 1556 557.771 1556C561.924 1556 565.608 1554 567.905 1550.93C570.202 1554.01 573.885 1556 578.038 1556C584.981 1556 590.63 1550.41 590.63 1543.54H585.715C585.715 1547.73 582.272 1551.14 578.038 1551.14H578.027Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2214_43837",
    x1: 1080,
    y1: 1700,
    x2: 67.3105,
    y2: 1454.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BECA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2214_43837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1700,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2214_43837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1700,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2214_43837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 34,
    fill: "white",
    transform: "translate(463 1522)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultVertical);
export default __webpack_public_path__ + "static/media/default_vertical.0e650e81ff3d2d4066dd3c6617ff21b7.svg";
export { ForwardRef as ReactComponent };